// Sesión admin tal y como la consume el cliente (apps/admin).
// La validación real del JWT vive en apps/api; este schema es un
// recordatorio del shape común y útil para tipar el contexto.
import { z } from 'zod';

export const AdminSessionSchema = z.object({
  authenticated: z.literal(true),
  user: z.object({
    memberId: z.string(),
    email: z.string().email(),
    name: z.string().optional(),
    role: z.literal('admin'),
  }),
});

export type AdminSession = z.infer<typeof AdminSessionSchema>;
